import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GolfIcon from './GolfIcon';
import { useUserProfile } from '@/context/UserProfileContext';
import { mediumImpact } from '@/utils/capacitorUtils';
import { IonButton } from '@ionic/react';
import { cn } from '@/lib/utils';

interface ProfileMessageButtonProps {
  userId: string;
  className?: string;
}

const ProfileMessageButton: React.FC<ProfileMessageButtonProps> = ({ userId, className }) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { profile } = useUserProfile();

  const handleMessageClick = (recipientId: string) => {
    // Don't allow messaging yourself
    if (profile?.userId === recipientId) {
      return;
    }

    // Provide haptic feedback
    mediumImpact();

    // Navigate to the chat with this user
    history.push(`/messages/${recipientId}`);
  };

  return (
    <IonButton
      fill='outline'
      type="button"
      onClick={() => handleMessageClick(userId)}
      className={cn('text-muted-foreground', className)}
    >
      <GolfIcon name="message" className="mr-2" />
      {t('message')}
    </IonButton>
  );
};

export default ProfileMessageButton;
